import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import OrganizationArrivalRatesPerHour from "../../../components/organization/reports/daily/OrganizationArrivalRatesPerHour";
import {
  ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const DailyOrganizationArrivalRatesPerHour = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
    descriptionKey="ArrivalRatesPerHour"
    title={`${reportIndex}. Arrival Rates Per Hour`}
  >
    {({ data, renderConfig }) => (
      <OrganizationArrivalRatesPerHour reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationArrivalRatesPerHour;
